import React, { useState } from 'react'; // NEW: Import useState
import { SubFamily } from '../types/costwand.d';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from './ui/table.tsx';
import { Button } from './ui/button.tsx';
import Pagination from './ui/Pagination.tsx';
import { Spinner } from './ui/spinner.tsx'; // Import Spinner
import { apiClient } from '../api/apiClient.ts'; // NEW: Import apiClient

interface SubFamilyTableProps {
  subFamilies: SubFamily[];
  currentPage: number;
  totalPages: number;
  totalItems: number;
  onPageChange: (page: number) => void;
  onEdit: (subFamily: SubFamily) => void;
  onDelete: (id: number) => void;
  loading: boolean;
  error: string | null;
  baseEndpoint: string; // NEW: Add baseEndpoint prop
}

const SubFamilyTable: React.FC<SubFamilyTableProps> = ({
  subFamilies,
  currentPage,
  totalPages,
  totalItems,
  onPageChange,
  onEdit,
  onDelete,
  loading,
  error,
  baseEndpoint, // NEW: Destructure baseEndpoint
}) => {
  const [exportLoading, setExportLoading] = useState(false); // NEW: State for export loading

  const handleExportCsv = async () => {
    setExportLoading(true);
    try {
      await apiClient<void>(baseEndpoint, { downloadCsv: true });
    } catch (err: any) {
      // Error already handled by apiClient and globalErrorHandler
    } finally {
      setExportLoading(false);
    }
  };

  if (loading) return <p className="text-center text-muted-foreground flex items-center justify-center gap-2"><Spinner size="sm" /> Loading subfamilies...</p>;
  if (error) return <p className="text-center text-destructive">Error: {error}</p>;
  if (subFamilies.length === 0 && !loading) return <p className="text-center text-muted-foreground">No subfamilies found.</p>;

  return (
    <div className="rounded-md border">
      <div className="flex justify-end mb-4"> {/* NEW: Wrapper for export button */}
        <Button onClick={handleExportCsv} disabled={loading || exportLoading} variant="outline">
          {exportLoading ? <span className="flex items-center gap-2"><Spinner size="sm" /> Exporting...</span> : 'Export to CSV'}
        </Button>
      </div>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Description</TableHead>
            <TableHead>Code</TableHead>
            <TableHead className="text-right">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {subFamilies.map((subFamily) => (
            <TableRow key={subFamily.id}>
              <TableCell className="font-medium">{subFamily.description}</TableCell>
              <TableCell>{subFamily.code}</TableCell>
              <TableCell className="flex justify-end gap-2">
                <Button variant="outline" size="sm" onClick={() => onEdit(subFamily)}>Edit</Button>
                <Button variant="destructive" size="sm" onClick={() => onDelete(subFamily.id!)}>Delete</Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        totalItems={totalItems}
        onPageChange={onPageChange}
      />
    </div>
  );
};

export default SubFamilyTable;